import { montarPaginacao, paginacaoDa, termoDa, type PaginacaoNaUrl } from '@/lib/paginacao-na-url';
import { termoDaBusca } from '@/lib/texto';

/* Reexportados para a pagina ter UM import do assunto. */
export { OPCOES_POR_PAGINA, PADRAO_POR_PAGINA } from '@/lib/paginacao-na-url';

/**
 * O estado dos filtros do estoque vive na URL (p.16).
 *
 * A conversa do estoque é por link: "olha o que está abaixo do mínimo no
 * depósito da obra". Com os quatro filtros em `useState`, o link abria a lista
 * inteira — e o filtro que nasce do clique no indicador, que é o caminho mais
 * usado, não sobrevivia nem a um recarregamento.
 */
export const SITUACOES_DO_FILTRO = ['abaixo', 'sem_saldo'] as const;

export type SituacaoDoFiltro = (typeof SITUACOES_DO_FILTRO)[number];

export type FiltroDeSituacao = SituacaoDoFiltro | '';

export function ehSituacaoDoEstoque(valor: unknown): valor is SituacaoDoFiltro {
  return typeof valor === 'string' && (SITUACOES_DO_FILTRO as readonly string[]).includes(valor);
}

export interface BuscaDoEstoque extends PaginacaoNaUrl {
  readonly termo?: string;
  readonly categoria?: string;
  readonly local?: string;
  readonly situacao?: SituacaoDoFiltro;
}

/**
 * `categoria` e `local` passam como texto livre, e é de propósito: as duas
 * listas vêm dos DADOS — as categorias que os itens têm e os depósitos que
 * existem —, não de um vocabulário fechado. Recusar um valor exigiria carregar
 * o estoque inteiro só para validar a URL, e uma categoria inexistente cai no
 * estado vazio filtrado, que já diz o que fazer.
 *
 * `situacao` tem vocabulário, e por isso é conferida: valor fora dele é
 * DESCARTADO, nunca corrigido no chute.
 */
export function validarBuscaDoEstoque(entrada: Record<string, unknown>): BuscaDoEstoque {
  /* O campo digitado guarda o texto inteiro (`termoDaBusca`); `termoDa` apara, e e para valor de lista. */
  const termo = termoDaBusca(entrada['termo']);
  const categoria = termoDa(entrada['categoria']);
  const local = termoDa(entrada['local']);
  const situacao = entrada['situacao'];
  return {
    ...(termo === undefined ? {} : { termo }),
    ...(categoria === undefined ? {} : { categoria }),
    ...(local === undefined ? {} : { local }),
    ...(ehSituacaoDoEstoque(situacao) ? { situacao } : {}),
    ...paginacaoDa(entrada),
  };
}

/** Monta a busca para navegar, deixando de fora tudo que já é o padrão. */
export function montarBuscaDoEstoque(estado: {
  readonly termo: string;
  readonly categoria: string;
  readonly local: string;
  readonly situacao: FiltroDeSituacao;
  readonly pagina: number;
  readonly porPagina: number;
}): BuscaDoEstoque {
  const termo = termoDaBusca(estado.termo);
  const categoria = termoDa(estado.categoria);
  const local = termoDa(estado.local);
  return {
    ...(termo === undefined ? {} : { termo }),
    ...(categoria === undefined ? {} : { categoria }),
    ...(local === undefined ? {} : { local }),
    ...(estado.situacao === '' ? {} : { situacao: estado.situacao }),
    ...montarPaginacao(estado),
  };
}
